import styles from "./DateInput.module.scss";

const DateInput = ({
	label = "",
	name = "",
	value = "",
	onChange = () => {},
	required = false,
}) => {
	return (
		<div className={styles.dateField}>
			{label ? <label className={styles.label}>{label}</label> : null}
		<input
			type="date"
			name={name}
			value={value}
			onChange={onChange}
			required={required}
			className={`${styles.input} ${
				value ? styles.inputFilled : styles.inputEmpty
			}`}
		/>
	</div>
);
};

export default DateInput;
